import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1750.17647,0 L1750.17647,1468.23529 L1524.29412,1468.23529 L1524.29412,1807.05882 L1693.70588,1807.05882 L1693.70588,1920 L451.352941,1920 C368.905882,1920 289.847059,1883.85882 235.635294,1820.61176 C192.717647,1769.78824 169,1704.28235 169,1637.64706 L169,1637.64706 L169,282.352941 C169,126.494118 295.494118,0 451.352941,0 L451.352941,0 L1750.17647,0 Z M1411.35294,1468.23529 L463.776471,1468.23529 C374.552941,1468.23529 297.752941,1529.22353 284.2,1608.28235 C283.070588,1617.31765 281.941176,1626.35294 281.941176,1634.25882 L281.941176,1634.25882 L281.941176,1637.64706 C281.941176,1678.30588 295.494118,1716.70588 322.6,1747.2 C354.223529,1785.6 401.658824,1807.05882 451.352941,1807.05882 L451.352941,1807.05882 L1411.35294,1807.05882 L1411.35294,1694.11765 L408.435294,1694.11765 L408.435294,1581.17647 L1411.35294,1581.17647 L1411.35294,1468.23529 Z M1354.88235,903.529412 L564.294118,903.529412 L564.294118,1016.47059 L1354.88235,1016.47059 L1354.88235,903.529412 Z M1411.35294,338.823529 L507.823529,338.823529 L507.823529,790.588235 L1411.35294,790.588235 L1411.35294,338.823529 Z M620.764706,677.647059 L1298.41176,677.647059 L1298.41176,451.764706 L620.764706,451.764706 L620.764706,677.647059 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconCoursesSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconCoursesSolid, _Component);

  var _super = _createSuper(IconCoursesSolid);

  function IconCoursesSolid() {
    _classCallCheck(this, IconCoursesSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconCoursesSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconCourses",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconCoursesSolid.displayName = "IconCoursesSolid";
  return IconCoursesSolid;
}(Component);

IconCoursesSolid.glyphName = 'courses';
IconCoursesSolid.variant = 'Solid';
IconCoursesSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconCoursesSolid;
export { IconCoursesSolid };